module.exports = __webpack_public_path__ + "static/logo-redify-b998ba0793260b816c822bb4766f3ef7.png";